import { render, staticRenderFns } from "./ProjectsMobile.vue?vue&type=template&id=d83a9c12"
import script from "./ProjectsMobile.vue?vue&type=script&lang=js"
export * from "./ProjectsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports